import _slicedToArray from "@babel/runtime/helpers/esm/slicedToArray";
import React, { useState } from "react";
import { Grid, Button, DataTable, DialogUser, makeStyles } from "../../../.."; // import { Link } from 'react-router-dom';

var useStyles = makeStyles(function (theme) {
  return {
    root: {
      padding: "4px 25px"
    },
    divider: {
      height: "4px"
    },
    mr30: {
      margin: "30px"
    },
    header: {
      display: "flex",
      "align-items": "center",
      "justify-content": "flex-end"
    },
    tabContainer: {
      display: "flex"
    },
    skeleton: {
      padding: "30px",
      width: "60%"
    }
  };
});

var UsersCentral = function UsersCentral(_ref) {
  var data = _ref.data,
      columns = _ref.columns,
      title = _ref.title,
      options = _ref.options,
      language = _ref.language,
      createUserCentral = _ref.createUserCentral;

  var _useState = useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      open = _useState2[0],
      setOpen = _useState2[1];

  var classes = useStyles();

  var handleDialog = function handleDialog() {
    setOpen(!open);
  };

  return [/*#__PURE__*/React.createElement(Grid, {
    item: true,
    md: 12,
    className: classes.header
  }, /*#__PURE__*/React.createElement(Button, {
    size: "medium",
    className: classes.mr30,
    color: "primary",
    variant: "outlined" // component={Link}
    // to="/franchises"
    ,
    onClick: handleDialog
  }, "+ Add Team member")), /*#__PURE__*/React.createElement(Grid, {
    item: true,
    md: 12,
    className: classes.editor
  }, /*#__PURE__*/React.createElement(DataTable, {
    key: language + "_users",
    type: "users",
    columns: columns,
    title: title,
    options: options,
    data: data
  })), /*#__PURE__*/React.createElement(DialogUser, {
    open: open,
    onClose: handleDialog,
    variant: "add",
    createUserCentral: createUserCentral
  })];
};

export default UsersCentral;